export default "__VITE_ASSET__KhluBAta__"